import { createAction } from '@reduxjs/toolkit';

import { ActionClearType, INITIALIZE_CUSTOM_PAGE_DATA } from 'constants/redux-actions';

const initializeCustomPageData = createAction(INITIALIZE_CUSTOM_PAGE_DATA);
const clearCustomPageData = createAction(ActionClearType(INITIALIZE_CUSTOM_PAGE_DATA));

const customPageActions = {
  initializeCustomPageData,
  clearCustomPageData,
};

export default customPageActions;
